import store from '@/store'

function getNotesList(source, sourceKey) {
  return new Promise((resolve, reject) => {
    store
      .dispatch('notes/apiCall', {
        mode: 'Select',
        request: {
          // all: process.env.VUE_APP_API_ALL,
          srt: 'createdOn',
          desc: false,
          source,
          sourceKey,
        },
      })
      .then(response => {
        if (response.success) {
          resolve(response.data.items)
        } else {
          reject(response.error)
        }
      })
      .catch(error => {
        reject(error)
      })
  })
}

export default getNotesList
